<template>
	<div>
			<!-- 搜索筛选 -->
			<!-- <el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="代码">
				<el-select v-model="formInline.futuresCode" placeholder="选择代码" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in futureCodes"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="K线种类">
				<el-select v-model="formInline.futuresType" placeholder="选择K线种类" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in futureTypes"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="initData">搜索</el-button>
			</el-form-item>
		</el-form> -->


	<div class="echart" id="mychartKLine" style="width:100%; height: 1000px;"></div>
	<div class="echart" id="mychartBar" style="width:100%; height: 600px;"></div>
	</div>
</template>
  
  <script>
  import * as echarts from "echarts";

  import {
	getAllFutureCodes,
	getAllFutureTypes,
	getFuturesQuoteTLIHL
	} from '../../api/basisMG.js'
  
  export default {
	data() {
	return {
		upcolor: "#FF0000", //增长颜色
		upBorderColor: "#8A0000",
		downColor: "#008000", // 下跌颜色
		downBorderColor: "#008F28",
		futureCodes:[],
		futureTypes:[],
		klineDatatl8: [], //k线图数据
		klineDataihl8: [], //k线图数据
		bldates:[]
	  };
	},
	methods: {
		getAllCodeTypes() {
				getAllFutureCodes().then(res => {
					if (res.code == '200') {
						this.futureCodes = res.data
						console.log("this.futureCodes",this.futureCodes)
					}
				})
				getAllFutureTypes().then(res => {
					if (res.code == '200') {
						this.futureTypes = res.data
						console.log("this.futureTypes",this.futureTypes)
					}
				})
			},


	  initData() {
		let param = this.formInline
		param.futuresCode='TL8'
		getFuturesQuoteTLIHL(param).then(res => {
			this.saveParams(this.$route.path,param)
			if (res.code == '200') {
				this.listDatatl8 = res.data.tl8Quotes
				this.klineDatatl8 = this.splitData(this.listDatatl8);
				this.listDataihl8 = res.data.ihl8Quotes
				this.klineDataihl8 = this.splitDataihl(this.listDataihl8);
				this.bldates=res.data.bldates;
				this.initEchartsKLine();
				this.initEchartsBar();
			}
		});
	  },
	  abc(params){
alert('abc');
	  },
	  initEchartsKLine() {
		const option = {
		  title: {text: "十债上证期货背离日",left: 0},
		  tooltip: {trigger: "axis",axisPointer: {type: "cross"}},
		  legend: {data: ["日K", "MA5", "MA10", "MA20", "MA60","消息"]},
		//   grid: {left: "10%",right: "10%",bottom: "15%"},
		grid: [
			{x: '7%',y: '3%',height: '45%',left: '10%',bottom: '3%'},
			{x: '7%',y2: '3%',height: '45%',left: '10%',bottom: '3%'}
		],
		xAxis: [
			{data: this.klineDatatl8.dates,
			type: "category",min: "dataMin",max: "dataMax",boundaryGap: false,
			axisLine: { onZero: false },splitLine: { show: false }},
			{data: this.klineDataihl8.dates,gridIndex: 1, 
			type: "category",min: "dataMin",max: "dataMax",boundaryGap: false,
			axisLine: { onZero: false },splitLine: { show: false }}
		],
		yAxis: [
			{scale: true,splitArea: { show: true}},
			{scale: true,gridIndex: 1,splitArea: { show: true}}
		],
		dataZoom: [
			{realtime: true,start: 95,end: 100,xAxisIndex: [0, 1],show: true},
			{realtime: true,start: 95,end: 100,xAxisIndex: [0, 1],type: 'inside',}
		],
		series: [
			{
			  name: "日K",type: "candlestick",xAxisIndex: 1,yAxisIndex: 1,
			  data: this.klineDataihl8.values,
			  itemStyle: {color: this.upColor,color0: this.downColor,borderColor: this.upBorderColor,borderColor0: this.downBorderColor},
			},
			{
			  name: "日K",type: "candlestick",
			  data: this.klineDatatl8.values,
			  itemStyle: {color: this.upColor,color0: this.downColor,borderColor: this.upBorderColor,borderColor0: this.downBorderColor},
			  markPoint: {
                itemStyle: { color: "green"},
                symbolSize:25, // 标记点大小
				data:this.klineDatatl8.markPointDatas
			}
			//   markLine: {
			// 	symbol: ["none", "none"],
			// 	data: [
			// 	  [
			// 		{name: "从低到高",
			// 		  type: "min",valueDim: "lowest",symbol: "circle",symbolSize: 10,
			// 		  label: {show: false},
			// 		  emphasis: {label: {show: false}}
			// 		},
			// 		{
			// 		  type: "max",valueDim: "highest",symbol: "circle",symbolSize: 10,
			// 		  label: {show: false},
			// 		  emphasis: {label: {show: false}}
			// 		}
			// 	  ],
			// 	  {name: "min line on close",type: "min",valueDim: "close"},
			// 	  {name: "max line on close",type: "max",valueDim: "close"}
			// 	]
			//   }
			},
			{name: "MA5",type: "line",data: this.calculateMA(this.klineDatatl8,5),smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 0.8}},
			{name: "MA10",type: "line",data: this.calculateMA(this.klineDatatl8,10),smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 0.8}},
			{name: "MA20",type: "line",data: this.calculateMA(this.klineDatatl8,20),smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 0.8}},
			{name: "MA60",type: "line",data: this.calculateMA(this.klineDatatl8,60),smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 0.8}},
			{name: "消息",type: "scatter",data: this.klineDatatl8.msgs},

			{name: "MA5",type: "line",xAxisIndex: 1,yAxisIndex: 1,data: this.calculateMA(this.klineDataihl8,5),smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 0.8}},
			{name: "MA10",type: "line",xAxisIndex: 1,yAxisIndex: 1,data: this.calculateMA(this.klineDataihl8,10),smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 0.8}},  
		]
		};
		const myChart = echarts.init(document.getElementById("mychartKLine"));
		myChart.setOption(option);
		myChart.on("click",function(params){
			console.log('params',params);
			if (params.componentType==='markPoint'){
				alert('abc');
			}else if(params.componentType=== 'series'){
				alert('123');
			}
			
		});
		window.addEventListener("resize", () => {myChart.resize();});
	  },


	  initEchartsBar() {
		const option = {
		  title: {text: "十债上证期货每年背离情况"},
		  tooltip: {trigger: "axis",axisPointer: {type: "cross"}},
		  legend: {data: ["背离", "不背离"]},
		  grid: {left: "10%",right: "10%",bottom: "15%"},
		  xAxis: {
			data: this.bldates.times,
			type: "category",boundaryGap: false,
			axisLine: { onZero: true },splitLine: { show: false }
		  },
		  yAxis: {scale: true,splitArea: { show: true}},
		  dataZoom: [
			{type: "inside",start: 0,end: 100},
			{type: "slider",start: 0,end: 100,show: true,top: "90%"}
		  ],
		  series: [
			{name: "背离",type: "bar",data: this.bldates.blcounts,itemStyle: {color: this.upColor},label: {show: true,  position: 'top'}},
			{name: "不背离",type: "bar",data: this.bldates.bblcounts,itemStyle: {color: this.upColor},label: {show: true,  position: 'top'}}
		  ]
		};
		const myChart = echarts.init(document.getElementById("mychartBar"));
		myChart.setOption(option);
		window.addEventListener("resize", () => {myChart.resize();});
	  },
	  // 数据计算以及拆分
	  splitData(rawData) {
		console.log("rawData",rawData)
		const dates = [];
		const values = [];
		const markPointDatas=[];
		const msgs=[];
		for (let i = 0; i < rawData.length; i++) {
			dates.push(rawData[i].time);
			msgs.push(rawData[i].msg);
		  	values.push([rawData[i].o,rawData[i].c,rawData[i].l,rawData[i].h]);  
			if (rawData[i].issame<1){  
				markPointDatas.push({value:'背',itemStyle: {color: 'rgb(41,60,85)'},coord: [rawData[i].time, 104]});
			}
		}
		return {
			dates: dates,
			values: values,
			markPointDatas:markPointDatas,
			msgs:msgs
		};
	  },
	  splitDataihl(rawData) {
		console.log("rawData",rawData)
		const dates = [];
		const values = [];
		for (let i = 0; i < rawData.length; i++) {
			dates.push(rawData[i].time);
		  	values.push([rawData[i].o,rawData[i].c,rawData[i].l,rawData[i].h]);  
		}
		return {
			dates: dates,
			values: values,
		};
	  },
	  // 均值计算
	  calculateMA(klinedata,dayCount) {
		const result = [];
		for (let i = 0, len = klinedata.values.length; i < len; i++) {
		  if (i < dayCount) {
			result.push("-");
			continue;
		  }
		  let sum = 0;
		  for (let j = 0; j < dayCount; j++) {
			sum += +klinedata.values[i - j][1];
		}
		  // 保留两位小数
		  result.push((sum / dayCount).toFixed(2));
		}
		return result;
	  },
	},
	mounted() {this.initData();},
	// created() {this.getAllCodeTypes()},
  };
  </script>
  
  